<template>
<div class="page-container">
    <v-overlay :z-index="10000" absolute :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <md-app style="min-height: 100vh;">
        <md-app-toolbar class="main-bar" md-elevation="2">
            <span class="md-title">HD TOLDOS</span>
        </md-app-toolbar>

        <md-app-drawer md-permanent="clipped">
            <md-list :md-expand-single="expandSingle">
                <md-list-item to="/">
                    <md-icon>home</md-icon>
                    <span class="md-list-item-text">Inicio</span>
                </md-list-item>

                <md-list-item to="/servico">
                    <md-icon>design_services</md-icon>
                    <span class="md-list-item-text">Serviços</span>
                </md-list-item>

                <md-list-item to="/projeto">
                    <md-icon>home_repair_service</md-icon>
                    <span class="md-list-item-text">Projetos</span>
                </md-list-item>

                <md-list-item to="/estoque">
                    <md-icon>table_rows</md-icon>
                    <span class="md-list-item-text">Estoque</span>
                </md-list-item>

                <md-list-item to="/movimentos">
                    <md-icon>move_up</md-icon>
                    <span class="md-list-item-text">Movimentos de estoque</span>
                </md-list-item>

                <md-list-item to="/configuracoes/medida">
                    <md-icon>scale</md-icon>
                    <span class="md-list-item-text">Unidades de Medida</span>
                </md-list-item>
            </md-list>
        </md-app-drawer>

        <md-app-content>
            <slot></slot>
        </md-app-content>
    </md-app>
</div>
</template>

<script>
export default {
    name: 'main-template',

    data () {
      return {
        expandEstoque: false,
        expandSingle: false
      }
    },
    props: {
        loading: Boolean
    }
}
</script>

<style>
.main-bar {
    background-color: #2a3342 !important;
    color: #FFF !important;
}

.main-bar .md-title {
    font-family: 'Roboto';
    color: #FFF !important;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 1px !important;
}
</style>